import type { FiltersGroup } from '@app/types/Filters';
import { FiltersTypeEnum } from '@app/models/api/enums/FiltersTypeEnum';
import { goto } from '$app/navigation';
import { smoothScrollToTop } from '$lib/utils/window';

const countCheckedFilters = (fg: FiltersGroup) => {
	return fg.filters.reduce(
		(p, c) =>
			p +
			((fg.type === FiltersTypeEnum.CHIP && c.checked) ||
			(fg.type === FiltersTypeEnum.SELECT && c.value)
				? 1
				: 0),
		0
	);
};

export const getNumberOfActiveFilters = (filters: FiltersGroup[]) => {
	return filters.reduce((p, c) => p + countCheckedFilters(c), 0);
};

export const hasOneActiveFilter = (filters: FiltersGroup[]) => {
	return getNumberOfActiveFilters(filters) > 0;
};

export const resetFilters = async () => {
	smoothScrollToTop();
	const currentURL: URL = new URL(window.location.toString());
	currentURL.search = '';
	await goto(currentURL);
};
